import styled from 'styled-components';

import {
  Dropdown as SemanticDropdown,
  Table as SemanticTable,
} from 'semantic-ui-react';

import {
  Text as TextLayoutComponent,
  Toggle as ToggleLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Table = styled(SemanticTable)``;

export const Text = styled(TextLayoutComponent)``;

export const Status = styled.div`
  display: flex;
  gap: 10px;
`;

export const Link = styled.a``;

export const Dropdown = styled(SemanticDropdown)``;

export const Toggle = styled(ToggleLayoutComponent)``;
